import {Action} from "redux";
import {ICustomerMessageRoomsActionCreator} from "../action/customer_message_rooms_action";

interface ICustomerMessageRoomsDispatcher {

    startPollingMessageRooms(): void;

    stopPollingMessageRooms(): void;
}

class Dispatcher implements ICustomerMessageRoomsDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: ICustomerMessageRoomsActionCreator) {

    }

    public startPollingMessageRooms = (): void => {
        this.dispatch(this.actionCreator.requestStartPollingMessageRoomsAction());
    }

    public stopPollingMessageRooms = (): void => {
        this.dispatch(this.actionCreator.requestStopPollingMessageRoomsAction());
    }

}

const createCustomerMessageRoomsDispatcher = (dispatch: (action: Action) => void, actionCreator: ICustomerMessageRoomsActionCreator): ICustomerMessageRoomsDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {ICustomerMessageRoomsDispatcher, createCustomerMessageRoomsDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/customer_message_rooms_dispatcher.ts